import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { MenuRequest, SaveResponse } from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import MenuAccordions from "./MenuAccordions";

const MenuCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { menuService, menusUrl, menuDetailsUrl } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "menuFormCreateButton" }));

  const onSubmit = async (values: MenuRequest) => {
    try {
      const response: SaveResponse = await registerPromise(
        menuService.saveMenu(values)
      );
      queryClient.invalidateQueries("menus");
      navigate(menuDetailsUrl(response.id));
      return response;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <RedirectBackButton
        redirectRoute={menusUrl()}
        labelKey="backToListButtonLabel"
        style={{ marginRight: "10px" }}
      />
      <Box my={2}>
        <Typography variant="h5">
          <T id="menuFormCreateTitle" />
        </Typography>
      </Box>
      <MenuAccordions
        onSubmit={onSubmit}
        onCancel={() => {
          navigate(menusUrl());
        }}
        submitLabel={t({ id: "menuFormCreateButton" })}
      />
    </>
  );
};

export default MenuCreateForm;
